import { SectionMessage } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useLocalStorage } from 'react-use'

import { LocalStorageKeys } from '../../../../enums/localStorageKeys'
import { getIsExportLimitReached } from '../../utils/getIsExportLimitReached'

interface SalesReportExportLimitBannerProps {
  localStorageKey: LocalStorageKeys
  bannerMessage: string
  salesReportCount: number
}

export const SalesReportExportLimitBanner = ({
  localStorageKey,
  bannerMessage,
  salesReportCount,
}: SalesReportExportLimitBannerProps): ReactElement | null => {
  const [isExportLimitBannerClosed, setIsExportLimitBannerClosed] = useLocalStorage<boolean | undefined>(
    localStorageKey,
  )

  const isExportLimitReached = getIsExportLimitReached(salesReportCount)
  const shouldShowExportLimitBanner = isExportLimitReached && !isExportLimitBannerClosed

  const handleCloseButtonClick = useCallback(() => setIsExportLimitBannerClosed(true), [setIsExportLimitBannerClosed])

  if (!shouldShowExportLimitBanner) {
    return null
  }

  return (
    <SectionMessage closable icon="info" onClose={handleCloseButtonClick} showIcon variant="info">
      {bannerMessage}
    </SectionMessage>
  )
}
